export enum AvailabilityType {
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME',
  HOURLY = 'HOURLY'
}

export const AVAILABILITY_TYPE_MAP = {
  [AvailabilityType.FULL_TIME]: 'Full Time',
  [AvailabilityType.HOURLY]: 'Hourly',
  [AvailabilityType.PART_TIME]: 'Part Time',
};